import InView from 'inview';

document.addEventListener('DOMContentLoaded', ()=> {
            
    const anims = document.querySelectorAll('.anim');
    
    const isInView = (el)=> {
        let bottomOfWindow = (window.pageYOffset || window.scrollY) + window.innerHeight;
        
        if ( el.getBoundingClientRect().top + (window.pageYOffset || window.scrollY) < bottomOfWindow ) {
            return true;
        }
    };
    
    window.inviewInit = ()=> {        
        for (let i = 0; i < anims.length; i++) {
            isInView(anims[i]) ? anims[i].classList.add('anim--visible') : false;

            let inview = InView(anims[i], (isInView)=> {
                if (isInView) {
                    anims[i].classList.add('anim--visible');
                   // inview.destroy();
                }
            });
        }
    };

}, false);
